module.exports = __webpack_public_path__ + "img/主页.2889ecb3.svg";